import {ContentStringDto} from "../../../models/dtos/contentString.dto";
import axios from "../../../utilities/axios";

export const getContentsRequest = async (): Promise<ContentStringDto[]> => {
  try {
    const response = await axios.get<ContentStringDto[]>(
      `${process.env.REACT_APP_BASE_URL}/content-strings`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
